import React from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { CircularProgressWithLabelProps } from './interfaces';

const CircularProgressWithLabel: React.FC<CircularProgressWithLabelProps> = (
  props,
) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography color="primary">{`${props.value}%`}</Typography>
      </Box>
    </Box>
  );
};

export default CircularProgressWithLabel;
